// extracted by mini-css-extract-plugin
export default {"isActiveClass":"Custom_isActiveClass__d1G2J","no_scrollbar":"Custom_no_scrollbar__i-XJ+","customDropdownScroll":"Custom_customDropdownScroll__KpasW"};